<template>
  <div class="wrap">
    <div class="follow" ref="inboxRef">
      <div class="bg_w">
        <span class="span" style="font-size: 13px;min-width: 70px">{{
            group ? $t('select.user') : $t('common.emailbox.select')
          }}：</span>
        <el-select v-model="selectedTeamId" @change="handleSelectUser" :placeholder="$t('common.email.chooseEmail')"
                   style="margin-right: 10px;width: 150px!important;" size="small">
          <el-option
              v-for="item in tableDataSelect"
              :label="item.userName"
              :value="item.userId"
              :key="item.userId"
          />
        </el-select>
        <el-select v-model="configId" style="width: 150px !important;" size="small">
          <el-option :label="$t('common.setting.allEmail')" value="all" id="all"/>
          <el-option
              v-for="item in emailList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
          />
        </el-select>
        <div style="flex-grow: 1;"></div>
      </div>
      <div class="screen">
        <div class="screen_btn">
          <!--          <ElButton size="small" :loading="btnIsLoadingResolve" type="primary" @click="() => handlePass(1)">-->
          <!--            {{ $t('email.list.examine') }}-->
          <!--          </ElButton>-->
          <!--          <ElButton size="small" :loading="btnIsLoadingReject" @click="() => handlePass(2)">-->
          <!--            {{ $t('email.list.examine.reject') }}-->
          <!--          </ElButton>-->
          <ElButton type="primary" size="small" @click="() => handleBatch(1)">{{ $t('common.bulk.delay') }}</ElButton>
          <ElButton size="small" @click="() => handleBatch(2)">{{ $t('common.bulk.cancel') }}</ElButton>
        </div>
        <el-pagination
            v-model:current-page="current"
            v-model:page-size="size"
            small="small"
            v-if="total"
            layout="total, prev, pager, next, jumper"
            :total="total"
            @current-change="handleCurrentChange"
        />
      </div>
      <div class="content">
        <!-- {{ list}} -->
        <div class="Drag2" ref="DragBox">
          <div class="box" ref="box">
            <!--      <div class="left">-->
            <!--        &lt;!&ndash;左侧div内容&ndash;&gt;-->
            <!--      </div>-->
            <!--      <div class="resize" title="左右侧边栏">⋮</div>-->
            <div class="mid">
              <!--右侧div内容-->
              <div class="topBox" :style="{height: topPanelHeight + 'px'}">
                <!--右上div内容-->
                <ElTable v-loading="loading"
                         :data="list"
                         row-key="id"
                         @selection-change="handleSelectionChange"
                         size="small"
                         ref="tableRef"
                         :height="'auto'"
                         highlight-current-row
                         @current-change="handleCurrentRowChange"
                         :cell-style="rowClassName"
                         :header-cell-style="headerClassName"
                         :row-style="{height: '30px'}"
                         :row-class-name="tableRowClassName"
                         @cell-mouse-enter="mouseEnters"
                         @cell-mouse-leave="mouseLeaves"
                         @sort-change="sort_change"
                         @row-dblclick="handleViewDetail"
                >
                  <el-table-column type="selection" :reserve-selection="true" width="20"/>
                  <el-table-column width="20" prop="isStress" sortable="custom"
                                   class-name="sort_ps"
                  >
                    <template #header>
                      <img style="position: absolute;left: 6px;top: 9px;" src="@/assets/email/hp.svg"/>
                    </template>
                    <template #default="scope">
                      <img v-if="scope.row.isStress === 1" style="position: absolute;left: 6px;top: 9px;"
                           @click.stop="() => handleSettingStress(scope, 3)"
                           class="pointer flags_f"
                           src="@/assets/email/hp.svg"/>
                      <img v-else class="pointer flags_f" style="position: absolute;left: 6px;top: 9px;"
                           @click.stop="() => handleSettingStress(scope, 2)"
                           src="@/assets/email/hp1.svg"/>
                    </template>
                  </el-table-column>
                  <el-table-column width="30" prop="isRead" sortable="custom" class-name="sort_ps">
                    <template #header>
                      <img style="position: absolute;left: 8px;top: 9px;" src="@/assets/email/weidu.svg"/>
                    </template>
                    <template #default="scope">
                      <img style="position: absolute;left: 8px;top: 6px" v-if="scope.row.isRead === 1"
                           @click.stop="() => handleSetRead(scope)" class="pointer"
                           src="@/assets/email/yidu.svg"/>
                      <img style="position: absolute;left: 8px;top:9px" v-else class="pointer"
                           @click.stop="() => handleSetRead(scope)"
                           src="@/assets/email/weidu.svg"/>
                    </template>
                  </el-table-column>
                  <el-table-column width="20" prop="fj" sortable="custom" class-name="sort_ps">
                    <template #header>
                      <img style="position: absolute;left: 6px;top:9px" src="@/assets/email/fj.svg"/>
                    </template>
                    <template #default="scope">
                      <img style="position: absolute;left: 6px;top:9px" v-if="scope.row.isExtend === 1" class="pointer"
                           src="@/assets/email/fj.svg"
                           @click.stop="() => handleDownload(scope)"/>
                    </template>
                  </el-table-column>
                  <el-table-column prop="receiveList" :label="$t('common.email.to')" width="200px">
                    <template #default="scope">
                      <!-- 有客户或联系人时 -->
                      <template v-if="scope.row.customerName || scope.row.contactName">
                        <OverflowTooltip
                            :content="scope.row.contactEmail || `${scope.row.customerName} (${scope.row.companyEmail})`"
                            :show-after="1200"
                            :max-width="180"
                        >
                          <router-link :to="`/email/customer/detail/${scope.row.customerId}?type=1`">
          <span
              class="tooltip-content-wrap"
              style="color: var(--el-color-primary);width: 100%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
          >
            {{ scope.row.customerName }}
          </span>
                          </router-link>
                        </OverflowTooltip>
                      </template>

                      <!-- 有多个收件人 -->
                      <template v-else-if="(scope.row.mailRecipientList?.length || 0) > 1">
                        <OverflowTooltip
                            :content="scope.row.mailRecipientList.join(', ')"
                            :show-after="1200"
                            :max-width="180"
                        >
        <span class="tooltip-content-wrap">
          {{ scope.row.mailRecipientList[0] }} ...
        </span>
                        </OverflowTooltip>
                      </template>

                      <!-- 只有一个收件人或其他情况 -->
                      <template v-else>
                        <OverflowTooltip
                            :content="scope.row.customerName || scope.row.mailRecipientList?.[0] || ''"
                            :show-after="1200"
                            :max-width="180"
                        >
        <span class="tooltip-content-wrap">
          {{ scope.row.customerName || scope.row.mailRecipientList?.[0] }}
        </span>
                        </OverflowTooltip>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column width="18">
                    <template #default="scope">
                      <img
                          v-if="scope.row.urgent === 1"
                          src="../../assets/svg/warning.svg"
                          class="urgent-icon"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column prop="subject" :label="$t('common.subject')">
                    <template #default="scope">
                      <div
                          class="subject-cell"
                          style="display: flex; align-items: center; position: relative;"
                      >
                        <!-- 紧急图标 -->
                        <!--                        <img-->
                        <!--                            v-if="scope.row.urgent === 1"-->
                        <!--                            src="../../assets/svg/warning.svg"-->
                        <!--                            class="urgent-icon"-->
                        <!--                        />-->

                        <!-- 内容部分，是否溢出决定是否显示 tooltip -->
                        <OverflowTooltip
                            :content="scope.row.subject"
                            :show-after="1200"
                        >
                          <a
                              @click.stop="handleViewDetail(scope.row)"
                              class="subject-text"
                          >
                            <span v-html="highlightKeyword(scope.row.subject, searchCount)"></span>
                          </a>
                        </OverflowTooltip>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="sendDate" :label="$t('common.email.sendTime')" class-name="sort_ps"
                                   sortable="custom" width="160"/>
                  <el-table-column prop="followTime" :label="$t('common.followup.time')" width="160"/>
                  <el-table-column prop="remark" :label="$t('common.remark')" width="80">
                    <template #default="scope">
                      <div class="flex">
                        <!--                         @click.stop="handleRef(refMap[`${scope.row.id}`], scope.row, 1)"-->
                        <el-icon :ref="(el) => (refMap[`${scope.row.id}`] = el)"
                                 @click.stop="handleClickRemark(scope.row)"
                                 :color="scope.row.remark ? '#409eff' : '#dddddd'" style="padding-top: -2px">
                          <el-tooltip
                              v-if="emailListCheckoutTarget.remark"
                              class="box-item"
                              :content="emailListCheckoutTarget.remark"
                              placement="right"
                              :show-after="1200"
                          >
                            <Memo/>
                          </el-tooltip>
                          <Memo v-else/>
                        </el-icon>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column fixed="right" :label="$t('common.cz')" :width="lang==='en'?180:140">
                    <template #default="scope">
                      <el-button link type="primary" size="small" @click="handleReply(scope.row)"
                      >{{ $t('common.followup') }}
                      </el-button
                      >
                      <el-button link type="primary" size="small" @click="handleDelay(scope.row)">{{
                          $t('common.delay')
                        }}
                      </el-button>
                      <el-popconfirm
                          width="220"
                          :confirm-button-text="$t('common.confirm')"
                          :cancel-button-text="$t('common.cancel')"
                          :icon="QuestionFilled"
                          icon-color="#faad14"
                          :title="$t('sys.message.ask.followup.cancel')"
                          @confirm="handleCancel(scope.row)"
                      >
                        <template #reference>
                          <el-button link type="primary" size="small">{{ $t('common.cancel') }}</el-button>
                        </template>
                      </el-popconfirm>
                    </template>
                  </el-table-column>
                  <template #empty>
                    <el-empty :description="$t('common.data.empty')" :image="emptyUrl"></el-empty>
                  </template>
                </ElTable>
              </div>
              <div
                  :title="$t('common.email.dragResizePanels')"
                  class="mover"
              >
                <div class="mail_info" ref="moveTarget">
                  <div
                      :title="$t('common.email.dragResizePanels')"
                      class="up_row move"
                      @pointerdown.prevent="handleVerticalResizeStart"
                  ></div>
                  <div style="width: 100%;height: 26px;display: flex">
                    <div class="from over_text">
                      {{ $t('common.email.from') }}：{{ currentMail?.mailBody?.from }}
                    </div>
                    <div class="to over_text" ref="toRef">
                      <el-popover
                          v-if="currentMailToText"
                          :visible="visibleTo"
                          width="500"
                          :show-after="1200"
                          :content="currentMailToText"
                          :effect="'dark'"
                          popper-class="visible"
                      >
                        <template #reference>
                    <span @mouseenter="showPopover(currentMailToText,'to')"
                          @mouseleave="delayedHidePopover('to')">{{
                        $t('common.email.to')
                      }}：{{ currentMailToText }}</span>
                        </template>
                        <div @mouseenter="keepPopoverVisible('to')" @mouseleave="hidePopover('to')">
                          {{ currentMailToText }}
                        </div>
                      </el-popover>
                      <template v-else>
                        {{ $t('common.email.to') }}：{{ currentMailToText }}
                      </template>
                    </div>
                    <div class="cc over_text">
                      <el-popover
                          v-if="currentMailCcText"
                          :visible="visibleCC"
                          width="500"
                          :content="currentMailCcText"
                          :effect="'dark'"
                          popper-class="visible"
                      >
                        <template #reference>
                <span
                    @mouseenter="showPopover(currentMailCcText,'cc')"
                    @mouseleave="delayedHidePopover('cc')"
                >
                {{ $t('common.cc') }}：{{ currentMailCcText }}
                </span>
                        </template>
                        <div @mouseenter="keepPopoverVisible('cc')" @mouseleave="hidePopover('cc')">
                          {{ currentMailCcText }}
                        </div>
                      </el-popover>
                      <template v-else>
                        {{ $t('common.cc') }}：{{ currentMailCcText }}
                      </template>
                    </div>
                  </div>
                  <div
                      :title="$t('common.email.dragResizePanels')"
                      class="down_row move"
                      @pointerdown.prevent="handleVerticalResizeStart"
                  ></div>
                </div>
              </div>
              <div class="downBox" :style="{height: downPanelHeight + 'px'}">
                <div class="mail-preview-wrapper">
                  <div v-loading="detailLoading" class="mail-preview-frame">
                    <iframe ref="pageframe" id="pageframe" :srcdoc="iframeContent"
                            frameborder="0"
                            @load="handleIframeLoad"
                            :style="{width: '100%',height: '100%',pointerEvents: isDragging ? 'none' : 'auto'}"
                            :class="detailLoading?'scroll':'scroll loaded'"
                    ></iframe>
                    <div v-if="isDragging" id="mask"
                         :style="{position:'absolute',inset:'0',background:'rgba(0,0,0,0)',zIndex:999}">
                    </div>
                  </div>
                  <div v-if="showAttachmentPanel && attachmentList.length" class="attachment-panel">
                    <div class="attachment-panel-body">
                      <div
                          v-for="(item, index) in attachmentList"
                          :key="item.fileId || item.id || item.url || item.name || index"
                          class="file file-item"
                      >
                        <div class="attachment-item-main">
                          <FileIcon
                              :fileExtend="getAttachmentExt(item)"
                              :fileUrl="item.url"
                              :size="24"
                              :isAbbreviation="true"
                          />
                          <el-popover
                              placement="left"
                              :width="'max-content'"
                              effect="dark"
                              trigger="hover"
                              :content="item.name"
                              :show-after="1200"
                          >
                            <template #reference>
                              <a class="name contents text" @click.prevent="handleAttachmentDownload(item.url, item.name)">
                                {{ item.name }}
                              </a>
                            </template>
                          </el-popover>
                        </div>
                        <div class="attachment-item-meta">
                          {{ formatSize(item.extendSize) || '-' }}
                        </div>
                        <div class="attachment-item-actions">
                          <el-button link type="primary" size="small" @click="handleAttachmentDownload(item.url, item.name)">
                            {{ $t('common.download') }}
                          </el-button>
                          <el-button
                              v-if="isEmlAttachment(item)"
                              link
                              type="primary"
                              size="small"
                              @click="handleEmlAttachment(item)"
                          >
                            {{ $t('common.preview') }}
                          </el-button>
                          <el-button
                              v-else-if="canPreviewAttachment(item)"
                              link
                              type="primary"
                              size="small"
                              @click="handleDetailFile(item)"
                          >
                            {{ $t('common.preview') }}
                          </el-button>
                          <el-button link type="primary" size="small" @click="handleReSave(item)">
                            {{ $t('common.cloud.Rollover') }}
                          </el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-dialog
          v-model="dialogVisible"
          :title="$t('common.yst')"
          width="400"
      >
        <el-date-picker
            size="small"
            v-model="time"
            type="date"
            style="width: 200px;margin: auto;display: flex;margin-top: 10px"
            :disabled-date="disabledDate"
            format="YYYY-MM-DD HH:mm:ss"
            value-format="YYYY-MM-DD HH:mm:ss"
            :placeholder="$t('common.slt')">
        </el-date-picker>
        <template #footer>
        <span class="dialog-footer">
          <el-button size="small" @click="dialogVisible = false">{{ $t('common.sss16') }}</el-button>
          <el-button size="small" type="primary" @click="handleEntry">
            {{ $t('common.confirm') }}
          </el-button>
        </span>
        </template>
      </el-dialog>
      <el-dialog
          v-model="tipsVisible"
          align-center
          :title="$t('sys.team.info')"
          :width="'450'"
          class="system-prompt-dialog"
      >
        <div class="tips_t" style="display: flex; align-items: flex-start;font-size: 14px">
          <div class="t" style="margin: 0px 8px;">
            {{ $t('common.plqxsz') }}
          </div>
        </div>
        <template #footer>
        <span class="dialog-footer">
          <el-button size="small" @click="tipsVisible = false">{{ $t('common.sss16') }}</el-button>
          <el-button size="small" type="primary" @click="handleEntryTips">
            {{ $t('common.confirm') }}
          </el-button>
        </span>
        </template>
      </el-dialog>
      <!--组件抽离-->
      <!--    <el-popover-->
      <!--        virtual-triggering-->
      <!--        :virtual-ref="tempRef"-->
      <!--        v-model:visible="visiblePopover"-->
      <!--        placement="top"-->
      <!--        :width="204"-->
      <!--        trigger="click"-->
      <!--        show-after="500"-->
      <!--        popper-class="sp_model_popover"-->
      <!--        :popper-options="{-->
      <!--              modifiers: [{-->
      <!--		          name: 'offset',-->
      <!--		          options: {-->
      <!--			          offset: [8, 8]-->
      <!--		          }-->
      <!--	        }]-->
      <!--	    }">-->
      <!--      <div @mouseenter="keepPopoverVisible()" @mouseleave="hidePopover()">-->
      <!--        <el-input v-model="emailListCheckoutTarget.remark" style="width: 180px;"-->
      <!--                  :placeholder="$t('common.email.setBlockSize')" @keydown.enter.native.stop="okPopover"/>-->
      <!--        <div style="text-align: right; margin: 16px 0 0 0;">-->
      <!--          <el-button size="small" text @click.stop="cancelPopover">{{ $t('common.sss16') }}-->
      <!--          </el-button>-->
      <!--          <el-button size="small" type="primary" @click.stop="okPopover"-->
      <!--          >{{ $t('common.confirm') }}-->
      <!--          </el-button-->
      <!--          >-->
      <!--        </div>-->
      <!--      </div>-->
      <!--    </el-popover>-->
    </div>
  </div>
  <MoveTargetFile
      v-if="moveTargetFileVisitable"
      v-model="moveTargetFileVisitable"
      @close="closeMoveTarget"
      :is-head-line="true"
      :type="2"
      :activeItem="activeItem"
      :list="refreshCurrentMailDetail"
      :numberFlag="'2'"
      :mail="true"
  ></MoveTargetFile>
  <EmlPreviewDialog v-model="emlPreviewVisible" :attachment="emlPreviewAttachment" />
  <!--   添加备注   -->
  <Remark v-if="visitableRemark" v-model="visitableRemark" @close="closeRemark" :isHeadLine="false"
          :currentItem="currentItem" @getList="getList" :mailId="true"></Remark>
</template>
<script>
import {onMounted, ref, computed, watch, nextTick, onBeforeUnmount} from 'vue';
import {useStore} from 'vuex';
import {useRoute, useRouter} from 'vue-router';
import {ElMessage} from 'element-plus';
import {QuestionFilled} from '@element-plus/icons-vue'
import {requestFollowList, requestBatchUpdateFollow, requestUpdateMailRemark, requestMailAccessory} from '@/api/mail';
import {emptyUrl} from '@/utils/statusParams.js'
import {flexWidth} from "@/utils/tableWidth";
import {debouncePlus, throttle} from "@/utils/mylodash"
import {i18n} from "@/lang";
import Remark from "@/components/Remark/index.vue"
import {getMailByUserId, getMailDetails, tagMail} from "@/api";
import {addImgOnErrorAttribute, bindIframeLinkClickToNewTab, containsHtmlTags, convertLinksToHTML, convertToHTML} from "@/utils/iframe";
import {getTeamUserListAll} from "@/api/groups";
import Dialog from "@/components/Dialog.vue";
import OverflowTooltip from "@/components/OverflowTooltip/index.vue";
import {highlightKeyword} from "@/utils/util";
import sessionStore from "@/utils/sessionStore";
import {Storage} from "@/utils/storage";
import {replaceEmptyPTagsWithBr, resetCss} from "@/utils/TinyMCE";
import FileIcon from "@/components/File/FileIcon.vue";
import EmlPreviewDialog from "@/components/EmlPreviewDialog.vue";
import MoveTargetFile from "@/views/Cloud/Components/MoveTargetFile.vue";
import {
  audioFormat,
  downloadFile,
  excelFormat,
  formatSize,
  imgFormat,
  isEmlFile,
  pdfFormat,
  pptFormat,
  textFormat,
  videoFormat,
  wordFormat
} from "@/utils/file";
import {api as viewerApi} from "v-viewer";

const MAIL_DETAIL_TYPE = 6;

function buildRecipientTextMap(list) {
  if (!list || !list.length) {
    return {to: '', cc: ''};
  }
  const infoMap = {};
  list.forEach((item) => {
    if (!infoMap[item.mailType]) {
      infoMap[item.mailType] = [];
    }
    infoMap[item.mailType].push(item.mail);
  });
  return {
    to: infoMap.to ? infoMap.to.join(' , ') : '',
    cc: infoMap.cc ? infoMap.cc.join(' , ') : '',
  };
}

export default {
  computed: {
    QuestionFilled() {
      return QuestionFilled
    }
  },
  methods: {highlightKeyword, flexWidth},
  components: {
    EmlPreviewDialog,
    MoveTargetFile,
    FileIcon,
    OverflowTooltip,
    Dialog,
    QuestionFilled,
    Remark,
  },
  props: ['group'],
  setup(props) {
    const isShiftPressed = ref(false); // 标记 Shift 键是否被按下
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const teamId = computed(() => store.state.email.teamID);
    const name = ref('');
    const loading = ref(false);
    const current = ref(1);
    const size = ref(20);
    const total = ref(0);
    const list = ref([]);
    const multipleSelection = ref([]);
    const dialogVisible = ref(false);
    const tipsVisible = ref(false);
    const time = ref('');
    const iframeContent = ref('');
    const DragBox = ref(null);
    const dragBoxHeight = ref(0);
    // 上下拖动事件
    const moveTarget = ref(null);
    const pageframe = ref(null);
    const detailLoading = ref(false)
    const currentMail = ref({})
    const currentMailRecipientTextMap = computed(() => buildRecipientTextMap(currentMail.value?.mailRecipientVOList));
    const currentMailToText = computed(() => currentMailRecipientTextMap.value.to);
    const currentMailCcText = computed(() => currentMailRecipientTextMap.value.cc);
    const topBoxValue = ref(null);
    const downBoxValue = ref(null);
    const initialMouseY = ref(0);
    const isDragging = ref(false);
    const userInfo = computed(() => store.state.user.userInfo)

    const ACCOUNTS_STORAGE_KEY = 'accounts'
    const activeUserId = computed(() => {
      const fromUserInfo = userInfo.value?.id ?? userInfo.value?.userID ?? userInfo.value?.guid ?? userInfo.value?.account
      const fromAccounts = Storage.get(ACCOUNTS_STORAGE_KEY)?.currentId
      const id = fromUserInfo ?? fromAccounts
      return id === undefined || id === null ? '' : String(id)
    })
    // 语言
    const lang = computed(() => store.state.system.langLocal)

    const configId = ref('all');
    const selectedTeamId = ref('');
    const selectedFolder = ref("");
    const tableDataSelect = ref([]);
    const emailList = ref([]);
    const selectedUserIdMap = ref({});
    const showAttachmentPanel = ref(true);
    const attachmentList = computed(() => currentMail.value?.mailExtendList || []);
    const emlPreviewVisible = ref(false);
    const emlPreviewAttachment = ref(null);
    const previewableAttachmentTypes = Object.freeze([
      ...imgFormat,
      ...pdfFormat,
      ...wordFormat,
      ...excelFormat,
      ...videoFormat,
      ...audioFormat,
      ...pptFormat,
      ...textFormat
    ]);
    const pendingActionRows = ref([]);
    const pendingActionClearSelection = ref(true);
    const selectionRowMap = ref({});
    const currentPageSelectionIds = ref([]);
    const isRestoringSelection = ref(false);
    const targetFileList = computed(() => route.path !== '/email/inbox' && route.path !== '/email/has_send' && route.path !== '/email/draft' && route.path !== '/email/waste' && route.path !== '/email/foldergroup' ? [{
      "id": "99999",
      "fileName": i18n.global.t('common.emailbox.receive'),
    }, {
      "id": "99999",
      "fileName": i18n.global.t('common.has.sent'),
    }, ...store.state.sidebar.targetFileList.filter(item => item.id !== selectedFolder.value)] : store.state.sidebar.targetFileList.filter(item => item.id !== selectedFolder.value))

    const teamList = computed(() => store.state.email.teamList)
    const getRowKey = (row) => String(row.id);
    const syncMultipleSelection = () => {
      multipleSelection.value = Object.values(selectionRowMap.value);
    };
    const syncSelectionState = (rows = []) => {
      const pageIds = list.value.map(item => getRowKey(item));
      const nextPageSelectionIds = rows.map(item => getRowKey(item));
      const nextMap = {...selectionRowMap.value};

      pageIds.forEach((id) => {
        if (currentPageSelectionIds.value.includes(id) && !nextPageSelectionIds.includes(id)) {
          delete nextMap[id];
        }
      });

      rows.forEach((row) => {
        nextMap[getRowKey(row)] = row;
      });

      selectionRowMap.value = nextMap;
      currentPageSelectionIds.value = nextPageSelectionIds;
      syncMultipleSelection();
    };
    const removeRowsFromSelection = (rows = []) => {
      if (!rows.length) {
        return;
      }
      const nextMap = {...selectionRowMap.value};
      rows.forEach((row) => {
        delete nextMap[getRowKey(row)];
      });
      selectionRowMap.value = nextMap;
      currentPageSelectionIds.value = currentPageSelectionIds.value.filter((id) => nextMap[id]);
      syncMultipleSelection();
    };
    const clearSelectionState = async () => {
      selectionRowMap.value = {};
      currentPageSelectionIds.value = [];
      multipleSelection.value = [];
      pendingActionRows.value = [];
      pendingActionClearSelection.value = true;
      await nextTick();
      tableRef.value?.clearSelection?.();
    };
    const restoreCurrentPageSelection = async () => {
      await nextTick();
      if (!tableRef.value) {
        return;
      }

      isRestoringSelection.value = true;
      const selectedIdSet = new Set(Object.keys(selectionRowMap.value));
      const currentSelectedIdSet = new Set(
        (tableRef.value.getSelectionRows?.() || []).map(item => getRowKey(item))
      );
      const selectedIds = [];

      list.value.forEach((row) => {
        const rowKey = getRowKey(row);
        const shouldSelect = selectedIdSet.has(rowKey);
        const isSelected = currentSelectedIdSet.has(rowKey);

        if (shouldSelect) {
          selectedIds.push(rowKey);
        }

        if (shouldSelect !== isSelected) {
          tableRef.value.toggleRowSelection(row, shouldSelect);
        }
      });

      currentPageSelectionIds.value = selectedIds;
      syncMultipleSelection();
      await nextTick();
      tableRef.value?.doLayout?.();
      isRestoringSelection.value = false;
    };

    const handleSelectUser = async (val) => {
      console.log(val)
      // if (route.path === '/email/foldergroup') {
      console.log(val, 'val', selectedTeamId.value);
      await store.commit("sidebar/setTargetFileList", [])
      await store.dispatch("sidebar/getEmailGroupFileListApis", {teamId: teamId.value, userId: selectedTeamId.value})
      selectedFolder.value = targetFileList.value.filter(item => item.id !== "99999").length >= 1 ? targetFileList.value[1].id : "";
      current.value = 1;
      await clearSelectionState();
      await getList()
      // }
    }
    const handleSelectFolder = async (val) => {
      console.log(val, 'val')
      selectedFolder.value = val;
      current.value = 1;
      await clearSelectionState();
      await getList()
    }

    async function getAllUserList() {
      const result = await getTeamUserListAll({teamId: teamId.value});
      if (result.code !== 200) {
        ElMessage.error(result.message)
        return
      }
      console.log(result.result, 'result.result')

      // 如果没有查到相关的id那么就需要跳转到默认 选中项
      // await store.dispatch('email/getTeamList');
      if (result.result && result.result.length === 0) {
        if (teamList.value.length >= 1) {
          const nextTeamId = String(teamList.value[0].id)
          store.commit('email/setCurTeamID', nextTeamId)
        } else {
          store.commit('email/setCurTeamID', '')
          //   如果查询到没有团队的详情的话那么就跳转到首页
          router.push("/dashboard")
        }
      }
      console.log(result.result, 'result.result')
      if (!route.params.folderId) {
        tableDataSelect.value = result.result || [];
      } else {
        tableDataSelect.value = result.result.filter(item => String(item.userId) === activeUserId.value)
      }
      if (tableDataSelect.value.length) {
        console.log(tableDataSelect.value, tableDataSelect.value.find(_ => String(_.userId) === activeUserId.value), 'tableDataSelect.value')
        selectedTeamId.value = tableDataSelect.value.find(_ => String(_.userId) === activeUserId.value)?.userId;
        selectedUserIdMap.value = tableDataSelect.value.reduce((prev, item) => {
          prev[item.id] = item.userId;
          return prev;
        }, {});
      }
    }

    function getMailListConf() {
      getMailByUserId({teamId: teamId.value, userId: selectedTeamId.value || ''})
          .then((res) => {
            // // console.log(res.result, '邮箱配置列表');
            const list = res.result || [];
            emailList.value = list.map(item => ({label: item.username, value: item.id}));
          });
    }

    watch(() => teamId.value, async () => {
      console.log('组件团队ID 监听', teamId.value);
      current.value = 1;
      await clearSelectionState();
      await getList();
      if (teamId.value) {
        configId.value = 'all';
        await getMailListConf();
        await getAllUserList();
      }
    })
    watch(() => selectedTeamId.value, (value, item) => {
      console.log('组件团队ID 监听', teamId.value);
      if (selectedTeamId.value !== item) {
        // getList();
        getMailListConf();
        // store.dispatch("user/checkUserInfoIsAdmin", {teamId: teamId.value})
      }
    });


    async function getList(sort) {
      loading.value = true;
      let payload = {
        pageNo: current.value,
        pageSize: size.value,
        teamId: teamId.value,
        mailConfigId: configId.value === 'all' ? null : configId.value,
        userId: selectedTeamId.value,
        // orderTime: 2,
      }
      if (sort) {
        console.log(sort, 'sort')
        payload = {...payload, ...sort}
      }
      const result = await requestFollowList(payload);
      loading.value = false;
      if (result.code !== 200) {
        ElMessage.error(result.message);
        return;
      }
      const {records, total: counts} = result.result;
      list.value = records;
      total.value = counts;
      current.value = result.result?.current || current.value;
      await restoreCurrentPageSelection();
      console.log('跟进列表', result);
    }

    const tableRef = ref(null)

    function handleSelectionChange(val) {
      if (isRestoringSelection.value) {
        currentPageSelectionIds.value = val.map(item => getRowKey(item));
        return;
      }
      //判断是否按住shirt键盘
      console.log(isShiftPressed.value);
      endIndex = val.length > 1 ? list.value.findIndex(item => item.id === val[val.length - 1].id) : -1;
      const startIndex = val.length > 1 ? list.value.findIndex(item => item.id === val[val.length - 2].id) : -1;
      console.log(endIndex, startIndex);
      if (isShiftPressed.value && val.length > 1 && endIndex !== startIndex) {
        const start = startIndex < endIndex ? startIndex : endIndex;
        const end = endIndex < startIndex ? startIndex : endIndex;
        // console.log(start, end, '===============');
        for (let i = start; i <= end; i++) {
          const row = list.value[i];
          if (start === i || i === end) {
            continue;
          }
          console.log(row, '更新');
          if (row) {
            tableRef.value.toggleRowSelection(row, true); // 调用表格组件的方法来更新选中状态
          }
        }
        nextTick(() => {
          const selectedRows = tableRef.value.getSelectionRows();
          syncSelectionState(selectedRows);
          console.log(selectedRows, '当前选中行');
        });
      } else {
        //走正常逻辑
        syncSelectionState(val);
      }
    }


    async function handleCurrentRowChange(current) {
      console.log(current, 'ff');
      if (current) {
        detailLoading.value = true
        try {
          const result = await getMailDetails({id: current.mailId});
          let content = result.result?.mailBody?.content;
          detailLoading.value = false
          const insertionContent = `<script>
            function errorImage(img) {
                console.log(img,'img')
                img.onerror = null;
                img.src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAADElEQVR42mP4//8/AAX+Av4zEpUUAAAAAElFTkSuQmCC"
            }
        <\/script>`;
          if (!content) {
            iframeContent.value = replaceEmptyPTagsWithBr(resetCss + '')
          } else {
            if (containsHtmlTags(content)) {
              const replacedHtmlString = addImgOnErrorAttribute(content)
              console.log('content', replacedHtmlString);
              const res = replacedHtmlString.replace(/(<html[^>]*>)/, '$1' + insertionContent);
              iframeContent.value = replaceEmptyPTagsWithBr(resetCss + res);
            } else {
              // 纯图片需要直接展示
              if (content.indexOf('https://s3gw.cmbimg.com') !== -1) {
                iframeContent.value = replaceEmptyPTagsWithBr(resetCss + content);
              } else {
                iframeContent.value = replaceEmptyPTagsWithBr(resetCss + convertLinksToHTML(convertToHTML(content)))
              }
            }
          }
          currentMail.value = result.result;
        } catch (e) {
          detailLoading.value = false
        }
      }
    }

    function handleCurrentChange(page) {
      console.log(page);
      current.value = page;
      getList();
    }

    function formatText(list, type) {
      console.log(list, type);
      if (!list || !list.length) {
        return '';
      }
      const infoMap = list.reduce((prev, item) => {
        if (!prev[item.mailType]) {
          prev[item.mailType] = [];
        }
        prev[item.mailType].push(item.mail);
        return prev;
      }, {});
      return infoMap[type] ? infoMap[type].join(',') : '';
    }

    function getAttachmentExt(item = {}) {
      const fileName = item.name || item.fileName || '';
      const extIndex = fileName.lastIndexOf('.');
      if (extIndex === -1) {
        return '';
      }
      return fileName.substring(extIndex + 1).toLowerCase();
    }

    function canPreviewAttachment(item = {}) {
      return previewableAttachmentTypes.includes(getAttachmentExt(item));
    }

    function isEmlAttachment(item = {}) {
      return isEmlFile(item.name || item.fileName || item.url);
    }

    async function handleAttachmentDownload(url, fileName) {
      try {
        if (!url) {
          ElMessage.error('文件地址无效');
          return;
        }

        const safeUrl = url.replace(/^http:\/\//i, "https://");
        const response = await fetch(safeUrl, {method: "GET"});

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const blob = await response.blob();
        downloadFile(blob, fileName || safeUrl.split("/").pop() || "download");
        return true;
      } catch (error) {
        console.error('下载失败:', error);
        ElMessage.error("下载失败，请稍后重试");
        return false;
      }
    }

    async function handleEmlAttachment(item) {
      emlPreviewAttachment.value = item;
      emlPreviewVisible.value = true;
    }

    function openAttachmentWindow(url) {
      window.open(url, "_blank");
    }

    function buildOpenUrl(path, row, extra = "") {
      if (!row || !row.url || !row.name) {
        return "";
      }
      const safeUrl = row.url.replace(/^http:\/\//i, "https://");
      const ext = getAttachmentExt(row);

      return `${location.origin}/${path}`
          + `?url=${encodeURIComponent(safeUrl)}`
          + `&type=${encodeURIComponent(ext)}`
          + extra;
    }

    function showTargetPdf(row) {
      openAttachmentWindow(buildOpenUrl("showfile", row));
    }

    function showTargetText(row) {
      openAttachmentWindow(buildOpenUrl("showtext", row));
    }

    function showTargetVideo(row) {
      openAttachmentWindow(buildOpenUrl("showvideo", row));
    }

    function showTargetAudio(row) {
      openAttachmentWindow(buildOpenUrl("showaudio", row, `&title=${encodeURIComponent(row.name)}`));
    }

    function showTargetFile(row) {
      const images = [];
      let initialViewIndex = 0;

      attachmentList.value
          .filter(item => imgFormat.includes(getAttachmentExt(item)))
          .forEach((item) => {
            if (item.name === row.name) {
              initialViewIndex = images.length;
            }
            images.push({src: item.url?.replace(/^http:\/\//i, "https://") || ""});
          });

      viewerApi({
        images,
        options: {
          initialViewIndex
        }
      })
    }

    function handleDetailFile(item) {
      if (isEmlAttachment(item)) {
        handleEmlAttachment(item);
        return;
      }
      const fileExtend = getAttachmentExt(item);

      if (imgFormat.includes(fileExtend)) {
        showTargetFile(item)
      } else if (pdfFormat.includes(fileExtend)) {
        showTargetPdf(item);
      } else if (wordFormat.includes(fileExtend) || excelFormat.includes(fileExtend) || pptFormat.includes(fileExtend)) {
        window.open("https://view.officeapps.live.com/op/view.aspx?src=" + encodeURIComponent(item.url))
      } else if (textFormat.includes(fileExtend)) {
        showTargetText(item)
      } else if (videoFormat.includes(fileExtend)) {
        showTargetVideo(item)
      } else if (audioFormat.includes(fileExtend)) {
        showTargetAudio(item)
      } else {
        handleAttachmentDownload(item.url, item.name)
      }
    }

    const moveTargetFileVisitable = ref(false);
    const activeItem = ref([]);
    const closeMoveTarget = () => {
      moveTargetFileVisitable.value = false
      activeItem.value = []
    }
    const handleReSave = throttle((item) => {
      activeItem.value = [item]
      moveTargetFileVisitable.value = true
    }, 500)
    const getTargetMailId = ref(null)
    const refreshCurrentMailDetail = async () => {
      if (!getTargetMailId.value) {
        return;
      }
      await handleCurrentRowChange({mailId: getTargetMailId.value});
    }

    //取消
    function handleCancel(row) {
      time.value = ''
      batch(2, [row], false);
    }

    //延迟
    function handleDelay(row) {
      pendingActionRows.value = [row];
      pendingActionClearSelection.value = false;
      dialogVisible.value = true;
    }

    //批量操作
    async function batch(type, rows = multipleSelection.value, clearAfterSuccess = true) {
      if (!rows.length) {
        ElMessage.error(i18n.global.t('sys.tip.unselect.email'));
        return;
      }
      const result = await requestBatchUpdateFollow({
        type,
        teamId: teamId.value,
        mailFollowDTOList: rows.map(item => ({id: item.id, mailId: item.mailId})),
        time: time.value
      });
      if (result.code !== 200) {
        ElMessage.error(result.message);
        return;
      }
      console.log('批量处理', result);
      if (clearAfterSuccess) {
        await clearSelectionState();
      } else {
        removeRowsFromSelection(rows);
      }
      await getList();
      // 更新标志
      await store.dispatch('countshow/getTeamAllDataApis')
    }

    //批量操作
    function handleBatch(type) {
      if (!multipleSelection.value.length) {
        ElMessage.error('未选中任何邮件');
        return;
      }
      pendingActionRows.value = [...multipleSelection.value];
      pendingActionClearSelection.value = true;
      if (type === 1) {
        dialogVisible.value = true;
      } else {
        tipsVisible.value = true;
      }
    }

    function handleEntry() {
      if (!time.value) {
        ElMessage.warning(i18n.global.t('common.email.chooseTime'));
        return;
      }
      dialogVisible.value = false;
      const rows = pendingActionRows.value.length ? pendingActionRows.value : multipleSelection.value;
      batch(1, rows, pendingActionClearSelection.value);
      pendingActionRows.value = [];
      pendingActionClearSelection.value = true;
    }

    function handleEntryTips() {
      tipsVisible.value = false;
      time.value = ''
      const rows = pendingActionRows.value.length ? pendingActionRows.value : multipleSelection.value;
      batch(2, rows, pendingActionClearSelection.value);
      pendingActionRows.value = [];
      pendingActionClearSelection.value = true;
    }

    function handleReply(row) {
      console.log(row, 'rows');
      localStorage.setItem('follow', JSON.stringify(row))
      const query = {id: row.mailId, flag: row.flag, type: "follow"};
      if (row.customerId) {
        query.customerId = row.customerId;
      }
      // router.push({
      //   path: '/email/write_mail',
      //   query,
      // });
      const queryString = new URLSearchParams(query).toString();

      // 拼接完整 URL（假设是 hash 模式或 history 模式可视项目结构调整）
      const url = `${location.origin}/email/write_mail?${queryString}`;
      // 在新标签页打开
      window.open(url, '_blank');
      //   取消目标 邮件跟进
      let timer = setTimeout(() => {
        handleCancel(row)
        clearTimeout(timer)
      }, 300)
    }

    function disabledDate(date) {
      return date.getTime() < Date.now();
    }

    watch(() => teamId.value, () => {
      console.log('组件团队ID 监听', teamId.value);
      getList();
    });

    // 页面进行缩放
    const adjustContentPosition = debouncePlus(async () => {
      await nextTick()
      syncDragBoxHeight();
      await store.dispatch("system/getTargetHeight", {userId: activeUserId.value})
      await nextTick()
      applyStoredVerticalPanelsHeight();
      tableRef.value?.doLayout?.()
    }, 200)

    onMounted(async () => {
      loading.value = true;
      document.addEventListener('keydown', handleKeyDown);
      document.addEventListener('keyup', handleKeyUp);
      await nextTick()
      syncDragBoxHeight();
      store.commit("sidebar/setTargetFileList", [])
      store.commit("sidebar/setPageSetting", {type: 'pageNo', value: 1})

      store.dispatch("sidebar/getEmailGroupFileListApis", {teamId: teamId.value, userId: activeUserId.value})
      // elementTop.value = tableHeight.value
      store.dispatch('customer/getAreaNames')
      store.dispatch("cusList/getMailCustomerLevel", {teamId: teamId.value});

      await store.dispatch("system/getTargetHeight", {userId: activeUserId.value})
      applyStoredVerticalPanelsHeight();
      await getAllUserList();
      if (teamId.value) {
        await getList();
      }
      window.addEventListener('resize', adjustContentPosition);
    });

    onBeforeUnmount(() => {
      clearIframeScrollState();
      clearVerticalResizeState();
      window.removeEventListener('resize', adjustContentPosition);
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('keyup', handleKeyUp);
    });

    let endIndex = -1;
    //按住shirt键
    const handleKeyDown = (event) => {
      console.log(event.key, 'event.key')
      if (event.key === 'Shift' && event.keyCode === 16) {
        // console.log("进来了-----------------", event.key, event.keyCode);
        isShiftPressed.value = true;
      }
    };

    const handleKeyUp = (event) => {
      if (event.key === 'Shift' && event.keyCode === 16) {
        isShiftPressed.value = false;
      }
    };

    const rowClassName = ({row, column, rowIndex, columnIndex}) => {
      console.log(row, columnIndex, '333')
      if (columnIndex === 2 || columnIndex === 5 || columnIndex === 7 || columnIndex === 8 || columnIndex === 9) {
        return {'text-align': 'center'}
      } else {
        return {'text-align': 'left'}
      }
    }

    const headerClassName = ({row, column, rowIndex, columnIndex}) => {
      if (columnIndex === 2 || columnIndex === 5 || columnIndex === 7 || columnIndex === 8 || columnIndex === 9) {
        return {'text-align': 'center'}
      } else {
        return {'text-align': 'left'}
      }
    }

    const sidebarTargetNumber = computed(() => store.state.countshow.sidebarTargetNumber)
    watch(() => sidebarTargetNumber.value, async () => {
      await getList()
    })

    watch(() => configId.value, async () => {
      current.value = 1;
      await clearSelectionState();
      await getList();
    });

    // remark
    const refMap = ref([])
    const tempRef = ref(null)
    const visiblePopover = ref(false)
    const emailListCheckoutTarget = ref({remark: ''})
    const handleRef = debouncePlus((ref, item, type) => {
      tempRef.value = ref
      visiblePopover.value = true;
      emailListCheckoutTarget.value = item;
    }, 300)


    // ---------------
    const hidePopoverTimeout = ref(false)
    // 这里是开始点
    const mouseEnters = debouncePlus((row) => {
      emailListCheckoutTarget.value = row;
    }, 200)
    const mouseLeaves = () => {
      hidePopoverTimeout.value = setTimeout(() => {
        visiblePopover.value = false;
      }, 300);
    }
    const keepPopoverVisible = () => {
      if (hidePopoverTimeout.value) {
        clearTimeout(hidePopoverTimeout.value);
        hidePopoverTimeout.value = null;
      }
      visiblePopover.value = true;
    }
    const hidePopover = () => {
      visiblePopover.value = false;
    }
    const cancelPopover = () => {
      visiblePopover.value = false;
      emailListCheckoutTarget.value.remark = ''
    }
    // -----------------
    // 弹窗进行编辑备注
    const visitableRemark = ref(false)
    const currentItem = ref({remark: ""})
    const handleClickRemark = (row) => {
      const {id} = row
      console.log(id, row, 'id')
      currentItem.value = row
      visitableRemark.value = true
    }
    const closeRemark = () => {
      visitableRemark.value = false
    }


    const visibleTo = ref(false)
    const visibleCC = ref(false)

    function showPopover(string = '', flag) {
      if (moveTarget.value) {
        const itemWidth = Math.round((moveTarget.value.clientWidth - 40) * (1 / 3))
        const stringWidth = string.pxWidth('normal 12px PingFangSC, PingFang SC')
        console.log(itemWidth, stringWidth)
        if (stringWidth + 20 > itemWidth) {
          if (flag === "to") {
            visibleCC.value = false;
            visibleTo.value = true;
          } else if (flag === "cc") {
            visibleTo.value = false;
            visibleCC.value = true;
          }
          if (hidePopoverTimeout.value) {
            clearTimeout(hidePopoverTimeout.value);
            hidePopoverTimeout.value = null;
          }
        }
      }
    }

    function delayedHidePopover(flag) {
      hidePopoverTimeout.value = setTimeout(() => {
        flag === "to" ? visibleTo.value = false : visibleCC.value = false;
      }, 200); // Adjust delay as necessary
    }

    const minTopPanelHeight = 30;
    const minBottomPanelHeight = 0;
    const verticalPanelGap = 0;
    const verticalResizeBarHeight = 30;
    let verticalResizeFrame = null;
    let removeVerticalResizeListeners = null;
    let removeIframeScrollListeners = null;
    let iframeWheelFallbackFrame = null;
    const getMaxTopPanelHeight = () => Math.max(dragBoxHeight.value - minBottomPanelHeight - verticalPanelGap, minTopPanelHeight)
    const getClampedTopPanelHeight = (height) => {
      const safeHeight = Number.isFinite(height) ? height : minTopPanelHeight;
      return Math.min(Math.max(safeHeight, minTopPanelHeight), getMaxTopPanelHeight());
    }
    const getStoredFollowInboxLayoutTop = () => {
      const storedTop = Number(store.state.system.followInboxTop);
      if (Number.isFinite(storedTop) && storedTop > 0) {
        return storedTop;
      }

      const storedBottomHeight = Number(store.state.system.followInboxHeight);
      if (dragBoxHeight.value && Number.isFinite(storedBottomHeight) && storedBottomHeight >= 0) {
        return dragBoxHeight.value - storedBottomHeight - verticalPanelGap;
      }

      return minTopPanelHeight;
    }
    const syncVerticalPanelsHeight = (nextTopHeight) => {
      if (!dragBoxHeight.value) return;
      const fallbackTopHeight = Number.isFinite(topBoxValue.value) ? topBoxValue.value : getStoredFollowInboxLayoutTop();
      const topHeight = getClampedTopPanelHeight(nextTopHeight ?? fallbackTopHeight);
      topBoxValue.value = topHeight;
      downBoxValue.value = Math.max(dragBoxHeight.value - topHeight - verticalPanelGap, minBottomPanelHeight);
      elementTopRaw.value = topHeight;
      pageframeHeightRaw.value = downBoxValue.value;
    }
    const applyStoredVerticalPanelsHeight = () => {
      if (!dragBoxHeight.value) return;
      syncVerticalPanelsHeight(getStoredFollowInboxLayoutTop());
    }
    const syncDragBoxHeight = () => {
      if (!DragBox.value) return;
      dragBoxHeight.value = Math.max(DragBox.value.offsetHeight - verticalResizeBarHeight, 0);
      syncVerticalPanelsHeight();
    }
    const topPanelHeight = computed(() => Number.isFinite(topBoxValue.value) ? topBoxValue.value : getClampedTopPanelHeight(store.state.system.followInboxTop || minTopPanelHeight))
    const downPanelHeight = computed(() => {
      if (Number.isFinite(downBoxValue.value)) return downBoxValue.value;
      if (!dragBoxHeight.value) return Math.max(store.state.system.followInboxHeight || minBottomPanelHeight, minBottomPanelHeight);
      return Math.max(dragBoxHeight.value - topPanelHeight.value - verticalPanelGap, minBottomPanelHeight);
    })
    const followInboxTop = computed(() => topPanelHeight.value)
    const followInboxHeight = computed(() => downPanelHeight.value)
    const elementTopRaw = ref(followInboxTop.value);
    const elementTop = computed({
      get() {
        return elementTopRaw.value;
      },
      set(newValue) {
        elementTopRaw.value = newValue;
      },
    });
    const pageframeHeightRaw = ref(followInboxHeight.value);
    const pageframeHeight = computed({
      get() {
        return pageframeHeightRaw.value;
      },
      set(newValue) {
        pageframeHeightRaw.value = newValue;
      },
    });

    const saveTargetHeight = debouncePlus((userId, pageframeHeight, elementTop) => {
      store.dispatch("system/settingTargetHeight", {
        userId,
        followInboxHeight: pageframeHeight,
        followInboxTop: elementTop
      });
    }, 200);

    function updateVerticalPanelsHeight(moveLen, containerHeight) {
      dragBoxHeight.value = containerHeight;
      syncVerticalPanelsHeight(moveLen);
      saveTargetHeight(activeUserId.value, downBoxValue.value, topBoxValue.value);
    }

    function clearIframeScrollState() {
      if (iframeWheelFallbackFrame) {
        cancelAnimationFrame(iframeWheelFallbackFrame);
        iframeWheelFallbackFrame = null;
      }
      if (removeIframeScrollListeners) {
        removeIframeScrollListeners();
        removeIframeScrollListeners = null;
      }
    }

    function emitIframeScrollEvent() {
      const iframeEl = pageframe.value;
      const iframeDoc = iframeEl?.contentDocument;
      if (!iframeEl || !iframeDoc) {
        return;
      }
      const scrollTarget = iframeDoc.scrollingElement || iframeDoc.documentElement || iframeDoc.body;
      if (!scrollTarget) {
        return;
      }
      iframeEl.dispatchEvent(new Event('scroll'));
      iframeEl.dispatchEvent(new CustomEvent('iframe-scroll', {
        detail: {
          scrollTop: scrollTarget.scrollTop || 0,
          scrollLeft: scrollTarget.scrollLeft || 0,
          clientHeight: scrollTarget.clientHeight || 0,
          scrollHeight: scrollTarget.scrollHeight || 0,
        }
      }));
    }

    function bindIframeScrollListeners() {
      clearIframeScrollState();
      nextTick(() => {
        const iframeEl = pageframe.value;
        const iframeWin = iframeEl?.contentWindow;
        const iframeDoc = iframeEl?.contentDocument;
        if (!iframeEl || !iframeWin || !iframeDoc) {
          return;
        }

        const onIframeScroll = () => {
          if (isDragging.value) {
            return;
          }
          emitIframeScrollEvent();
        };
        const onIframeWheel = (event) => {
          const scrollTarget = iframeDoc.scrollingElement || iframeDoc.documentElement || iframeDoc.body;
          const beforeScrollTop = scrollTarget?.scrollTop || 0;
          const deltaY = event.deltaY || 0;
          if (isDragging.value || !scrollTarget || !deltaY) {
            return;
          }
          if (iframeWheelFallbackFrame) {
            cancelAnimationFrame(iframeWheelFallbackFrame);
          }
          iframeWheelFallbackFrame = requestAnimationFrame(() => {
            const activeScrollTarget = iframeDoc.scrollingElement || iframeDoc.documentElement || iframeDoc.body;
            if (!activeScrollTarget || activeScrollTarget.scrollHeight <= activeScrollTarget.clientHeight) {
              iframeWheelFallbackFrame = null;
              return;
            }
            if (activeScrollTarget.scrollTop === beforeScrollTop) {
              const maxScrollTop = Math.max(activeScrollTarget.scrollHeight - activeScrollTarget.clientHeight, 0);
              const nextScrollTop = Math.min(Math.max(beforeScrollTop + deltaY, 0), maxScrollTop);
              if (nextScrollTop !== beforeScrollTop) {
                activeScrollTarget.scrollTop = nextScrollTop;
                emitIframeScrollEvent();
              }
            }
            iframeWheelFallbackFrame = null;
          });
        };
        const passiveOptions = {passive: true};

        iframeWin.addEventListener('scroll', onIframeScroll, passiveOptions);
        iframeDoc.addEventListener('scroll', onIframeScroll, passiveOptions);
        iframeDoc.documentElement?.addEventListener('scroll', onIframeScroll, passiveOptions);
        iframeDoc.body?.addEventListener('scroll', onIframeScroll, passiveOptions);
        iframeWin.addEventListener('wheel', onIframeWheel, passiveOptions);
        iframeDoc.addEventListener('wheel', onIframeWheel, passiveOptions);
        iframeDoc.documentElement?.addEventListener('wheel', onIframeWheel, passiveOptions);
        iframeDoc.body?.addEventListener('wheel', onIframeWheel, passiveOptions);
        // 邮件正文中的链接/按钮点击后在新标签页打开对应地址
        const removeIframeLinkListener = bindIframeLinkClickToNewTab(iframeDoc, {
          shouldIgnore: () => isDragging.value,
        });

        removeIframeScrollListeners = () => {
          iframeWin.removeEventListener('scroll', onIframeScroll, passiveOptions);
          iframeDoc.removeEventListener('scroll', onIframeScroll, passiveOptions);
          iframeDoc.documentElement?.removeEventListener('scroll', onIframeScroll, passiveOptions);
          iframeDoc.body?.removeEventListener('scroll', onIframeScroll, passiveOptions);
          iframeWin.removeEventListener('wheel', onIframeWheel, passiveOptions);
          iframeDoc.removeEventListener('wheel', onIframeWheel, passiveOptions);
          iframeDoc.documentElement?.removeEventListener('wheel', onIframeWheel, passiveOptions);
          iframeDoc.body?.removeEventListener('wheel', onIframeWheel, passiveOptions);
          removeIframeLinkListener?.();
        };

        requestAnimationFrame(() => {
          emitIframeScrollEvent();
        });
      });
    }

    function handleIframeLoad() {
      bindIframeScrollListeners();
    }

    function clearVerticalResizeState() {
      isDragging.value = false
      document.body.style.cursor = "";
      document.body.style.userSelect = "";
      if (verticalResizeFrame) {
        cancelAnimationFrame(verticalResizeFrame);
        verticalResizeFrame = null;
      }
      if (removeVerticalResizeListeners) {
        removeVerticalResizeListeners();
        removeVerticalResizeListeners = null;
      }
    }

    function handleVerticalResizeStart(e) {
      syncDragBoxHeight();
      const containerHeight = dragBoxHeight.value;
      if (!containerHeight) return false;
      const startY = e.clientY;
      const startTop = topPanelHeight.value;
      const pointerTarget = e.currentTarget;
      const pointerId = e.pointerId;

      isDragging.value = true
      document.body.style.cursor = "row-resize";
      document.body.style.userSelect = "none";
      if (pointerTarget && Number.isFinite(pointerId)) {
        try {
          pointerTarget.setPointerCapture(pointerId);
        } catch (error) {
          console.warn('setPointerCapture failed', error);
        }
      }

      const handleMouseUp = () => {
        if (pointerTarget && Number.isFinite(pointerId)) {
          try {
            pointerTarget.releasePointerCapture(pointerId);
          } catch (error) {
            console.warn('releasePointerCapture failed', error);
          }
        }
        clearVerticalResizeState();
        saveTargetHeight(activeUserId.value, downPanelHeight.value, topPanelHeight.value);
        tableRef.value?.doLayout?.();
        requestAnimationFrame(() => {
          bindIframeScrollListeners();
        });
      };
      const handleVisibilityChange = () => {
        if (document.visibilityState !== 'visible') {
          handleMouseUp();
        }
      };

      const handleMouseMove = (moveEvent) => {
        if (moveEvent.buttons === 0) {
          handleMouseUp();
          return;
        }
        const deltaY = moveEvent.clientY - startY;
        const moveLen = startTop + deltaY;
        if (verticalResizeFrame) {
          cancelAnimationFrame(verticalResizeFrame);
        }
        verticalResizeFrame = requestAnimationFrame(() => {
          updateVerticalPanelsHeight(moveLen, containerHeight);
          verticalResizeFrame = null;
        });
      };

      removeVerticalResizeListeners = () => {
        window.removeEventListener('pointermove', handleMouseMove);
        window.removeEventListener('pointerup', handleMouseUp);
        window.removeEventListener('pointercancel', handleMouseUp);
        window.removeEventListener('blur', handleMouseUp);
        document.removeEventListener('visibilitychange', handleVisibilityChange);
      };
      window.addEventListener('pointermove', handleMouseMove);
      window.addEventListener('pointerup', handleMouseUp);
      window.addEventListener('pointercancel', handleMouseUp);
      window.addEventListener('blur', handleMouseUp);
      document.addEventListener('visibilitychange', handleVisibilityChange);

      return false;
    }


    function tableRowClassName({row, rowIndex}) {
      return `read_${row.isRead}`;
    }

    const commandList = [1, 0, 1, 0];

    async function handleSettingStress(scope, type) {
      // // console.log(scope.row, type);
      await requestTagMail(commandList[type], 'isStress', [scope.row]);
      // 更新标志
      // await store.dispatch('countshow/getTeamAllDataApis')
    }

    async function handleCommand(val) {
      // // console.log(val, multipleSelection.value);
      if (!multipleSelection.value.length) {
        ElMessage.error(i18n.global.t('sys.tip.unselect.email'));
        return;
      }
      const type = val === 0 || val === 1 ? 'isRead' : 'isStress';
      await requestTagMail(commandList[val], type);
    }

    async function requestTagMail(tag, type, rows = multipleSelection.value) {
      if (!rows.length) {
        ElMessage.error(i18n.global.t('sys.tip.unselect.email'));
        return;
      }
      const result = await tagMail({
        [type]: tag,
        mailIdList: rows.map(item => item.mailId),
      });
      if (result.code !== 200) {
        ElMessage.error(result.message);
        return;
      }
      // 更新标志
      await store.dispatch('countshow/getTeamAllDataApis')

      const rowIdSet = new Set(rows.map(item => getRowKey(item)));
      const nextMap = {...selectionRowMap.value};
      rows.forEach((row) => {
        const rowKey = getRowKey(row);
        if (nextMap[rowKey]) {
          nextMap[rowKey] = {...nextMap[rowKey], [type]: tag};
        }
      });
      selectionRowMap.value = nextMap;
      syncMultipleSelection();

      list.value = list.value.map(item => {
        if (rowIdSet.has(getRowKey(item))) {
          return {...item, [type]: tag}
        }
        return item
      })

      if (rows.length > 1) {
        await getList()
      }
    }


    const handleSetRead = async (scope) => {
      const isRead = scope.row.isRead;
      const result = await tagMail({
        isRead: isRead === 1 ? 0 : 1,
        mailIdList: [scope.row.mailId],
      });
      if (result.code !== 200) {
        ElMessage.error(result.message);
        return;
      }
      const rowKey = getRowKey(scope.row);
      if (selectionRowMap.value[rowKey]) {
        selectionRowMap.value = {
          ...selectionRowMap.value,
          [rowKey]: {...selectionRowMap.value[rowKey], isRead: isRead === 1 ? 0 : 1}
        };
        syncMultipleSelection();
      }
      list.value = list.value.map(item => {
        if (item.mailId === scope.row.mailId) {
          return {...item, isRead: isRead === 1 ? 0 : 1}
        } else {
          return item
        }
      })
    }


    async function handleDownload(scope) {
      const result = await requestMailAccessory({id: scope.row.mailId});
      if (result.code !== 200) {
        ElMessage.error(result.message);
        return;
      }
      console.log(result, 'result')
      window.open(`${location.origin}/email/detail/${scope.row.mailId}/${JSON.stringify({
        flag: scope.row.flag ? scope.row.flag : 0,
        isExtend: scope.row.isExtend ? scope.row.isExtend : 0,
        from: scope.row.from
      })}/${MAIL_DETAIL_TYPE}`);
    }

    const sortObj = ref({})

    function sort_change({column, prop, order}) {
      console.log('ffff', column, prop, order)
      if (order != null) {
        const flag = order === 'descending' ? 2 : 1;
        // 映射排序字段到相应的请求参数
        const sortMapping = {
          isStress: 'orderStress',
          isRead: 'orderRead',
          fj: 'orderExtend',
          sendDate: 'orderTime',
          contentSize: 'orderSize'
        };

        // 获取相应的请求参数
        const requestParam = sortMapping[prop];
        sortObj.value = {[requestParam]: flag};
        console.log(sortObj.value, 'sortObj')
        if (requestParam) {
          getList({[requestParam]: flag});
        }
      } else {
        getList()
      }
    }

    async function handleViewDetail(row) {
      console.log('双击', row, row.mailId);
      // if (props.type === 3) {
      //   const query = {id: row.id, flag: row.flag, type: "resend"};
      //   if (row.flag === 0 && row.customerId) {
      //     query.customerId = row.customerId;
      //   }
      //   router.push({
      //     path: '/email/write_mail',
      //     query,
      //   });
      // } else if (props.type === 2) {
      //   const query = {id: row.id, flag: row.flag, type: "editMail", fromType: props.type};
      //   if (row.flag === 0 && row.customerId) {
      //     query.customerId = row.customerId;
      //   }
      //   router.push({
      //     path: '/email/write_mail',
      //     query,
      //   });
      // } else {
      getTargetMailId.value = row?.mailId
      // 已读的邮件 避免被重复赋值
      if (row?.isRead !== 1) {
        await requestTagMail(commandList[0], 'isRead', [row]);
      }
      window.open(`${location.origin}/email/detail/${row.mailId}/${JSON.stringify({
        flag: row.flag ? row.flag : 0,
        isExtend: row.isExtend ? row.isExtend : 0,
        from: row.from,
        customerId: row.customerId,
      })}/${MAIL_DETAIL_TYPE}`);

      // window.location.href = `${location.origin}/email/detail/${row.id}/${JSON.stringify({
      //     flag: row.flag ? row.flag : 0,
      //     isExtend: row.isExtend ? row.isExtend : 0,
      //     from: row.from,
      //   })}/${props.type}`;
      await getList();
      // }
    }


    return {
      handleViewDetail,
      tableRef,
      sort_change,
      handleDownload,
      handleSetRead,
      handleCommand,
      handleSettingStress,
      tableRowClassName,
      targetFileList,
      emailList,
      configId,
      handleSelectFolder,
      tableDataSelect,
      selectedFolder,
      getAllUserList,
      handleSelectUser,
      selectedTeamId,
      DragBox,
      dragBoxHeight,
      currentMail,
      currentMailToText,
      currentMailCcText,
      formatSize,
      handleAttachmentDownload,
      handleEmlAttachment,
      canPreviewAttachment,
      isEmlAttachment,
      getAttachmentExt,
      handleDetailFile,
      handleReSave,
      showAttachmentPanel,
      attachmentList,
      emlPreviewVisible,
      emlPreviewAttachment,
      moveTargetFileVisitable,
      activeItem,
      closeMoveTarget,
      refreshCurrentMailDetail,
      saveTargetHeight,
      elementTop,
      pageframeHeight,
      isDragging,
      handleVerticalResizeStart,
      delayedHidePopover,
      showPopover,
      hidePopoverTimeout,
      visibleTo,
      visibleCC,
      formatText,
      iframeContent,
      detailLoading,
      handleIframeLoad,
      topBoxValue,
      topPanelHeight,
      downBoxValue,
      downPanelHeight,
      followInboxHeight,
      followInboxTop,
      pageframe,
      getList,
      currentItem,
      closeRemark,
      visitableRemark,
      handleClickRemark,
      hidePopover,
      keepPopoverVisible,
      cancelPopover,
      tempRef,
      visiblePopover,
      lang,
      handleRef,
      emailListCheckoutTarget,
      mouseEnters,
      mouseLeaves,
      refMap,
      rowClassName,
      headerClassName,
      name,
      current,
      size,
      list,
      total,
      loading,
      dialogVisible,
      tipsVisible,
      time,
      handleEntry,
      handleReply,
      handleEntryTips,
      disabledDate,
      handleBatch,
      handleCurrentChange,
      handleCurrentRowChange,
      handleSelectionChange,
      handleCancel,
      handleDelay,
      emptyUrl
    }
  }
}
</script>
<style lang="less" scoped>
@import "./less/follow_up";

.tooltip-content-wrap {
  max-width: 300px;
  max-height: 200px;
  overflow-y: auto;
  white-space: normal;
  word-break: break-word;
  padding: 4px;
}

.urgent-icon {
  width: 15px;
  height: 15px;
  position: relative;
  top: 3px;
}

:deep(.el-button+.el-button) {
  margin-left: 2px !important;
}

.mail-preview-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;
}

.mail-preview-frame {
  position: relative;
  flex: 1 1 auto;
  min-width: 0;
  height: 100%;
}

.attachment-panel {
  width: 250px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  flex-shrink: 0;
  font-size: 13px;
}

.attachment-panel-body {
  flex: 1 1 auto;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 8px 0 0;
}

.file {
  display: flex;
  flex-direction: column;
  padding: 8px;
  margin: 0 8px 8px;
  background: #fff;
  border: 1px solid #ebebeb;
  border-radius: 4px;
}

.attachment-item-main {
  display: flex;
  align-items: center;
  min-width: 0;
}

.attachment-item-main .name {
  margin-left: 8px;
  color: #40a9ff;
  font-size: 13px;
  line-height: 20px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
  min-width: 0;
  flex: 1 1 auto;
}

.attachment-item-meta {
  margin-top: 4px;
  color: #909399;
  font-size: 13px;
  line-height: 20px;
}

.attachment-item-actions {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  margin-top: 4px;
  flex-wrap: wrap;
}

.attachment-item-actions :deep(.el-button) {
  font-size: 13px !important;
}
</style>
